import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';
import { NewRelicService } from '../../../../../../angular-app/projects/brokerage-eapp/src/app/services/newrelic.service';
import { Router } from '@angular/router';
import { get, isArray } from 'lodash';

// services
import { NavigationService } from '../services/navigation.service';
import { ApiService } from 'src/app/services/api.service';

// App State
import { Store } from '@ngrx/store';
import { Observable, interval } from 'rxjs';
import { startWith, mergeMap, switchMap, takeWhile, first, take  } from 'rxjs/operators';
import { AppState, UPDATE_DECISION_INFO } from '../app-reducer';
import { TryCatchStmt } from '@angular/compiler';
import * as luxon from 'luxon';
import { CommonService } from '../services/common.service';
@Component({
  selector: 'processing',
  templateUrl: './processing.component.html'
})

export class ProcessingComponent implements OnInit {
  appState$: Observable<any>;
  processing: boolean;
  appID;
  appAuthID;
  productName;
  counter;
  faceAmount:number = 0;
  internalInterval: any;
  timeout: number = 7 * 60;
  timeLeft: number = 7 * 60;
  isDemo = false;
  demoDecision='demo-decision';
  decisionDetails='decision-details';

  constructor(
    private newRelicService: NewRelicService,
    public router: Router,
    private apiService: ApiService,
    private store: Store<AppState>,
    private navigationService: NavigationService,
    private changeDetection: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.appState$ = this.store.select('sections');
    this.processing = false;
  }

  ngOnInit() {
    this.newRelicService.addPageAction('ngOnInit Start', { status: 'started' });

    this.processing = true;

    let data;

    // get latest state
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      try {
        this.appID = state['appId'];
        this.appAuthID =  state['appAuthId'];
        this.productName =  state['content']['SECTIONDCoverageDetails']['ProductName'];
        const TermFaceAmount = state.content.SECTIONDCoverageDetails.TermFaceAmount ? state.content.SECTIONDCoverageDetails.TermFaceAmount : '0';
        let baseFaceAmount=Number(TermFaceAmount.replace(/\$/g,'').replace(/\,/g,''));
        this.isDemo = state.isDemo;
        console.log('TermFaceAmount',baseFaceAmount );
        if((isNaN(baseFaceAmount) ? 0 : baseFaceAmount) ==0){      
          baseFaceAmount=  this.calculateBaseFaceAmount(state); ;      
        }
        this.faceAmount=baseFaceAmount;
        this.newRelicService.addPageAction('State Retrieved', { appId: this.appID });
      } catch (e) {
        this.newRelicService.noticeError(e, { appId: this.appID });
        console.log('ERROR: ', e);
      }


      // decide flow path

      if (state.simulate && get(state, 'simulate.decision'))
      {
        setTimeout (() => {
          const decision = get(state, 'simulate.decision');
          if (decision == '1') {
            this.getDecisionAndGoForward(state, decision, 1)
          } else if (decision == '2') {
            this.getDecisionAndGoForward(state, decision, 2);
        }
        else if (decision == '2.5') {
            this.getDecisionAndGoForward(state, decision, 2.5);
        }
       else if (decision == '3') {
            this.getDecisionAndGoForward(state, decision, 3);
        }
      else if (decision == '4') {
            this.getDecisionAndGoForward(state, decision, 4);
          }
        }, 1000);
      } else {

        // generate policy number if not simulating

        data = {
          'appID': this.appID,
          'productName': this.productName
        };

        console.log('Policy Number assignment');
        // generate policy number
        this.generatePolicyNumber(data);

        this.pollDecision(state);
      }
    });

    this.newRelicService.addPageAction('ngOnInit End', { status: 'completed' });
  }

  calculateBaseFaceAmount(state: any) {
    const FlexiblePremiumProductsBaseAmount:string =state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsBaseAmount ? state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsBaseAmount :"0";
    console.log('FlexiblePremiumProductsBaseAmount:',FlexiblePremiumProductsBaseAmount );
    console.log('FlexiblePremiumProductsBaseAmount:',FlexiblePremiumProductsBaseAmount.replace(/\$/g,'').replace(/\,/g,''));
    const ProductsBaseAmount =Number(FlexiblePremiumProductsBaseAmount.replace(/\$/g,'').replace(/\,/g,''));
    console.log('ProductsBaseAmount:',ProductsBaseAmount );
    
    const FlexiblePremiumProductsSupplementalAmount:string =state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsSupplementalAmount ? state.content.SECTIONDCoverageDetails.FlexiblePremiumProductsSupplementalAmount : "0";
    console.log('FlexiblePremiumProductsSupplementalAmount:',FlexiblePremiumProductsSupplementalAmount);
    const SupplementalAmount = Number(FlexiblePremiumProductsSupplementalAmount.replace(/\$/g,'').replace(/\,/g,''));
    console.log('SupplementalAmount:',SupplementalAmount );
    
    return ((isNaN(ProductsBaseAmount) ? 0 : ProductsBaseAmount) + (isNaN(SupplementalAmount) ? 0 : SupplementalAmount));
         
  }

  getDecisionAndGoForward(state, decision: any, decisionNumber) {
    console.log('decision',decision);
    const sectionPayload = {
      appAuthId: state.appAuthId,
      appId: state.appId,
      simulateDecision:decisionNumber
    };

    this.apiService.getDecision(sectionPayload).subscribe(resonse =>
      {
        this.logDecisionResponse(resonse);
      this.store.dispatch({
        type: UPDATE_DECISION_INFO,
        payload: {}
      });
      this.appState$.pipe(
        first(),
        mergeMap((currentState: any) => {
          const requestPayload = {
            appAuthId: currentState.appAuthId,
            appId: currentState.appId,
            decisionInfo: {},
            faceAmount:this.faceAmount,
          };
          return this.apiService.saveInfo(requestPayload);
        })
      ).subscribe((response: any) => {});


      this.goToDecisionDetails();
    }, (error) => {
      this.newRelicService.noticeError(error, { appId: this.appID });
      console.log('error', error);
    });
  }
  logDecisionResponse(response: any) {
    console.log('decision response',response);
  }

  generatePolicyNumber(data: any) {
    this.newRelicService.addPageAction('generatePolicyNumber Start', { status: 'started', appId: this.appID });

    console.log('isDemo processing component', this.isDemo);    
    try {
      if (this.isDemo) {
        console.log('I am processing the demo application with policy number: ', 'DEMO_'+this.appID);
        const policyNumber = '';
        const processAppPayload = {
          AppId: this.appID,
          AppAuthId: this.appAuthID,
          PolicyNumber: policyNumber
        };

        this.apiService.processApplication(processAppPayload).subscribe(res => {
          console.log(res);
        }, (error) => {
          this.newRelicService.noticeError(error, { appId: this.appID });
          console.log('ERROR');
          console.log(error);
        });
      } else {
        this.apiService.generatePolicyNumber(data).subscribe(response => {
          this.newRelicService.addPageAction('Pol Num API Call Success', { status: 'success', appId: this.appID });

          const policyNumber = response.data.details.policyNumber;
          const processAppPayload = {
            AppId: this.appID,
            AppAuthId: this.appAuthID,
            PolicyNumber: policyNumber
          };

          this.apiService.processApplication(processAppPayload).subscribe(res => {
            console.log(res);
          }, (error) => {
            this.newRelicService.noticeError(error, { appId: this.appID });
            console.log('ERROR');
            console.log(error);
          });
        }, (error) => {
          this.newRelicService.noticeError(error, { appId: this.appID });
          console.log('ERROR');
          console.log(error);
        });
      }
    } catch (error) {
      this.newRelicService.noticeError(error, { appId: this.appID });
      console.log('Error', error);
    }

    this.newRelicService.addPageAction('generatePolicyNumber End', { status: 'completed', appId: this.appID });
  }

  // utility
  pollDecision(state: any) {
    this.newRelicService.addPageAction('pollDecision Start', { status: 'started', appId: this.appID });
      // request payload
      const sectionPayload = {
        appAuthId: state.appAuthId,
        appId: state.appId,
      };

      this.startDecisionTimer();

      // poll final decision
      interval(10000)
      .pipe(
        startWith(0),
        switchMap(() => {
          console.log('Try again :', luxon.DateTime.now().toFormat('hh:mm:ss').toString());
          return this.apiService.getDecision(sectionPayload);
        }),
        takeWhile((response: any) => {
        
        // get decision and hard failure check
        const decision = get(response, 'data.DecisionInfo.Rows');         
        const decisionReady = isArray(decision) && decision.length > 0;
        const hardFailureMsg: boolean = get(response, 'message.hardFailureMsg') ? true : false;

        if (decisionReady) {
          // update store with decision
          this.store.dispatch({
            type: UPDATE_DECISION_INFO,
            payload: { Rows: decision }
          });
        }

        if (decisionReady || hardFailureMsg) {
            // stop timer
          this.pauseDecisionTimer();

          // request payload for save info
          const requestPayload = {
            appAuthId: state.appAuthId,
            appId: state.appId,
            decisionInfo: decision ? { Rows: decision } : null,
            faceAmount: this.faceAmount,
          };

          // save info API call
          this.apiService.saveInfo(requestPayload).subscribe((saveInfoResponse) => {
            console.log('Decision Saved :', luxon.DateTime.now().toFormat('hh:mm:ss').toString());
            console.log('Time left', this.timeLeft);                
            console.log(saveInfoResponse);
            
            // TriagePathNumber = 1 (STP), TriagePathNumber = 2 (STP Validation), TriagePathNumber = 3 (FUW), TriagePathNumber = 4 (STP Decline)
            this.goToDecisionDetails();
          }, (errorResponse) => {
            // error
            this.newRelicService.noticeError(errorResponse, { appId: this.appID });
            this.goToDecisionDetails();
          });
        }
        
        if (this.timeLeft <= 0) {
          this.pauseDecisionTimer();
          this.goToDecisionDetails();
        }
      
        return !(decisionReady || this.timeLeft <= 0 || hardFailureMsg);
      })
    ).subscribe((response: any) => {}, (errorResponse: any) => {
      // error
      this.newRelicService.noticeError(errorResponse, { appId: this.appID });
      this.pauseDecisionTimer();
      this.goToDecisionDetails();
    });
  }   

  startDecisionTimer(){
    console.log('Decision Timer :', luxon.DateTime.now().toFormat('hh:mm:ss').toString());
    clearInterval(this.internalInterval);
    this.timeLeft = this.timeout;

    this.internalInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.counter=this.commonService.toMMSS((this.timeout - this.timeLeft));
        this.changeDetection.detectChanges(); 
      }
      if (this.timeLeft == 0) {
        this.goToDecisionDetails();
        this.pauseDecisionTimer();
      }
    }, 1000);
  }

  pauseDecisionTimer() {
    clearInterval(this.internalInterval);
    this.timeLeft = 0;
  }

  goToDecisionDetails(){
    if (this.isDemo){
      this.navigationService.nextSectionRelative(this.demoDecision);
     } else {
      this.navigationService.nextSectionRelative(this.decisionDetails);
    }
  }
}
